const defaultPixelsPerRem = '16';

interface IMeasurementConstructorParams {
   pixels: number;
   rem: number;
}

export default class Measurement {
   // One rem is equivalent to the font size, in pixels, of the root element (aka the document).
   static readonly pixelsPerRem = parseFloat(getComputedStyle(document.documentElement).fontSize || defaultPixelsPerRem);
   static readonly remPerPixel = 1 / Measurement.pixelsPerRem;
   static get zero() {
      return new Measurement({pixels: 0});
   }

   private readonly pixels: number;

   constructor({pixels = 0, rem = 0}: Partial<IMeasurementConstructorParams>) {
      this.pixels = pixels + (rem * Measurement.pixelsPerRem);
   }

   equals(other: unknown): boolean {
      if (other instanceof Measurement) {
         return other.pixels === this.pixels;
      }

      return false;
   }

   get inPixels(): number {
      return this.pixels;
   }

   get inRem(): number {
      return this.pixels * Measurement.remPerPixel;
   }
}
